(() => {
  if (window.__rxVideoPlayerInitialized) return;
  window.__rxVideoPlayerInitialized = true;

  document.addEventListener("click", (event) => {
    const button = event.target.closest(
      "[data-rx-video-player] .rx-video__play-button"
    );

    if (!button) return;

    const wrapper = button.closest("[data-rx-video-player]");
    const source = button.dataset.videoSrc;

    if (!wrapper || !source) return;

    let url;

    try {
      url = new URL(source, window.location.origin);
    } catch {
      return;
    }

    const allowedHosts = [
      "www.youtube.com",
      "www.youtube-nocookie.com",
      "player.vimeo.com",
    ];

    if (
      url.protocol !== "https:" ||
      !allowedHosts.includes(url.hostname)
    ) {
      return;
    }

    url.searchParams.set("autoplay", "1");
    url.searchParams.set("playsinline", "1");

    const iframe = document.createElement("iframe");

    iframe.src = url.toString();
    iframe.title =
      button.getAttribute("aria-label") || "Video player";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.allowFullscreen = true;

    wrapper.replaceChildren(iframe);
  });
})();